<template>
  <div>
    <!-- <div
      class="pb-2"
      v-if="
        !(
          (institution && institution.internal_use_id == 'duoc.cl')
        )
      "
    >
      <b-form-select
        v-model="selected_section_view"
        value-field="value"
        text-field="name"
        @change="changeSectionView()"
        class="mt-4 mb-1"
      >
        <option :value="null" disabled>
          -- Seleccione el Filtro a Utilizar --
        </option>
        <option
          v-for="section_view in sections_view"
          :key="section_view.value"
          :value="section_view.value"
        >
          {{ section_view.name }}
        </option>
      </b-form-select>
    </div> -->

    <div class="section-container pb-5">
      <div
        class="upper-egress-profile"
        v-if="egressProfileList.length > 1"
        v-b-tooltip.hover.bottom="lockedSelectorTooltip"
      >
        <p class="m-0">
          {{
            $getVisibleNames("mesh.egressprofile", true, "Perfiles De Egreso")
          }}
        </p>
        <b-form-select
          v-model="selected_egress_profile_id"
          :options="egressProfileList"
          value-field="id"
          text-field="name"
          :disabled="isCreatingOrEditingSection"
          @change="
            () => {
              selected_period_id = null;
            }
          "
          :placeholder="
            $getVisibleNames('mesh.egressprofile', true, 'Perfiles De Egreso')
          "
        ></b-form-select>
      </div>
      <div v-if="selected_section_view == 1" class="select-container">
        <div class="upper-selector" v-b-tooltip.hover.bottom="lockedSelectorTooltip">
          <p>
            {{
              $t("section.sectionView.programType", {
                entity: $getVisibleNames("mesh.career", false, "Programa"),
              })
            }}
          </p>
          <b-form-select
            v-model="profile_type_id"
            value-field="id"
            text-field="name"
            dense
            attach
            hide-details
            :disabled="isCreatingOrEditingSection"
            @change="
              () => {
                selected_career_id = null;
                selected_egress_profile_id = null;
                resetDependentFilters();
              }
            "
          >
            <option :value="null" selected>
              --
              {{
                $t("section.sectionView.selectProgramType", {
                  entity: $getVisibleNames("mesh.career", false, "Programa"),
                })
              }}
              --
            </option>
            <option
              v-for="type in profileTypes"
              :key="type.id"
              :value="type.id"
            >
              {{ type.name }}
            </option>
          </b-form-select>
        </div>
        <div class="upper-selector" v-b-tooltip.hover.bottom="lockedSelectorTooltip">
          <p>
            {{ $getVisibleNames("mesh.egressprofile", false, "Perfil de Egreso") }}
          </p>
          <v-select
            v-model="selected_career_id"
            :options="careerList"
            :reduce="(careerList) => careerList.id"
            :disabled="isCreatingOrEditingSection"
            :placeholder="
              `-- ${$t('section.sectionView.selectProgramToFilter', {
                entity: $getVisibleNames(
                  'mesh.egressprofile',
                  false,
                  'Perfil de Egreso'
                ),
                sections: $getVisibleNames(
                  'teaching.section',
                  true,
                  'Secciones'
                ),
              })} --`
            "
            label="name"
            track-by="id"
            size="sm"
            :filterBy="filterCareerOption"
            @input="
              (value) => {
                if (value == null) {
                  selected_egress_profile_id = null;
                  resetDependentFilters();
                } else {
                  selected_period_id = null;
                }
              }
            "
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                {{ $t("section.sectionView.noSearchResults") }}
                <em>{{ search }}</em
                >.
              </template>
            </template>
            <template v-slot:option="option">
              {{ getCareerDisplayName(option) }}
            </template>
            <template v-slot:selected-option="option">
              {{ getCareerDisplayName(option) }}
            </template>
          </v-select>
        </div>
        <div class="upper-selector">
          <p v-if="egressProfile">
            {{ $getVisibleNames("mesh.campus", false, "Sede") }}
          </p>
          <b-form-select
            v-if="egressProfile"
            v-model="selected_campus_id"
            :options="filteredCampuses"
            value-field="id"
            text-field="name"
            attach
            clearable
            dense
            hide-details
          >
            <template #first>
              <b-form-select-option :value="null"
                >--
                {{
                  $t("section.sectionView.selectA", {
                    article: "una",
                    entity: $getVisibleNames("mesh.campus", false, "Sede"),
                  })
                }}
                --</b-form-select-option
              >
            </template>
          </b-form-select>
        </div>
      </div>
      <div v-else-if="selected_section_view == 2">
        <div class="select-container">
          <div class="upper-selector">
            <p>
              <strong>
                {{ $getVisibleNames("teaching.matter", false, "Asignatura") }}
              </strong>
            </p>
            <v-select
              v-model="selected_matter_id"
              :options="sortMatters"
              :reduce="(sortMatters) => sortMatters.id"
              :placeholder="`-- ${$t('section.sectionView.selectA', {
                article: 'una',
                entity: $getVisibleNames(
                  'teaching.matter',
                  false,
                  'Asignatura'
                ).toLowerCase(),
              })} --`"
              label="label"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("section.sectionView.noSearchResults") }}
                  <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.label }}
              </template>
            </v-select>
          </div>
          <div class="upper-selector">
            <p>
              {{ $getVisibleNames("mesh.campus", false, "Sede") }}
            </p>
            <b-form-select
              v-model="selected_campus_id"
              :options="sortCampus"
              value-field="id"
              text-field="name"
              attach
              clearable
              dense
              hide-details
            >
              <template #first>
                <b-form-select-option :value="null"
                  >--
                  {{
                    $t("section.sectionView.selectA", {
                      article: "una",
                      entity: $getVisibleNames("mesh.campus", false, "Sede"),
                    })
                  }}
                  --</b-form-select-option
                >
              </template>
            </b-form-select>
          </div>
          <!-- <div class="upper-selector ml-2">
          <p class="ml-2">Nivel</p>
          <b-form-select
            v-model="selected_level"
            :options="levels"
            attach
            clearable
            dense
            hide-details
            label="Nivel"
            class="mt-4 mb-1 ml-2"
            ><template #first>
              <b-form-select-option :value="null"
                >-- Seleccione un Nivel --</b-form-select-option
              >
            </template></b-form-select
          >
        </div> -->
          <div class="upper-selector">
            <p>
              {{ $getVisibleNames("mesh.periodtype", false, "Régimen") }}
            </p>
            <b-form-select
              v-model="selected_period_type_id"
              :options="regimes"
              value-field="id"
              text-field="name"
              attach
              clearable
              dense
              hide-details
              @change="
                (value) => {
                  selected_period_id = null;
                }
              "
              :label="$getVisibleNames('mesh.periodtype', false, 'Régimen')"
              ><template #first>
                <b-form-select-option :value="null"
                  >--
                  {{
                    $t("section.sectionView.selectA", {
                      article: "una",
                      entity: $getVisibleNames(
                        "mesh.periodtype",
                        false,
                        "Régimen"
                      ),
                    })
                  }}
                  --</b-form-select-option
                >
              </template></b-form-select
            >
          </div>
        </div>
        <div class="select-container">
          <div class="lower-selector">
            <p>
              {{ $getVisibleNames("mesh.period", false, "Período") }}
            </p>
            <v-select
              v-model="selected_period_id"
              :options="periodList"
              :reduce="(periodList) => periodList.id"
              :placeholder="
                `-- ${$t('section.sectionView.selectA', {
                  article: 'una',
                  entity: $getVisibleNames('mesh.period', false, 'Período'),
                })} --`
              "
              label="name"
              track-by="id"
              size="sm"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{ $t("section.sectionView.noSearchResults") }}
                  <em>{{ search }}</em
                  >.
                </template>
              </template>
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </div>
          <div class="lower-selector">
            <p>
              {{ $getVisibleNames("mesh.shift", false, "Jornada") }}
            </p>
            <b-form-select
              v-model="selected_shift_id"
              :options="shifts"
              value-field="id"
              text-field="name"
              attach
              clearable
              dense
              hide-details
              :label="$getVisibleNames('mesh.shift', false, 'Jornada')"
              ><template #first>
                <b-form-select-option :value="null"
                  >--
                  {{
                    $t("section.sectionView.selectA", {
                      article: "una",
                      entity: $getVisibleNames("mesh.shift", false, "Jornada"),
                    })
                  }}
                  --</b-form-select-option
                >
              </template></b-form-select
            >
          </div>
        </div>
      </div>
      <div v-if="egressProfile" class="select-container">
        <div class="lower-selector">
          <p v-if="egressProfile">{{ $t("section.sectionView.level") }}</p>
          <b-form-select
            v-model="selected_level"
            :options="levels"
            attach
            clearable
            dense
            hide-details
            :label="$t('section.sectionView.level')"
            ><template #first>
              <b-form-select-option :value="null"
                >--
                {{ $t("section.sectionView.selectLevel") }}
                --</b-form-select-option
              >
            </template></b-form-select
          >
        </div>
        <div class="lower-selector">
          <p v-if="egressProfile">
            {{ $getVisibleNames("mesh.period", false, "Período") }}
          </p>
          <v-select
            v-model="selected_period_id"
            :options="periodList"
            :reduce="(periodList) => periodList.id"
            :placeholder="
              `-- ${$t('section.sectionView.selectA', {
                article: 'un',
                entity: $getVisibleNames('mesh.period', false, 'Período'),
              })} --`
            "
            label="label"
            track-by="id"
            size="sm"
          >
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                {{ $t("section.sectionView.noSearchResults") }}
                <em>{{ search }}</em
                >.
              </template>
            </template>
            <template v-slot:option="option">
              {{ option.label }}
            </template>
          </v-select>
        </div>
        <div class="lower-selector">
          <p v-if="egressProfile">
            {{ $getVisibleNames("mesh.shift", false, "Jornada") }}
          </p>
          <b-form-select
            v-model="selected_shift_id"
            :options="shifts"
            value-field="id"
            text-field="name"
            attach
            clearable
            dense
            hide-details
            :label="$getVisibleNames('mesh.shift', false, 'Jornada')"
            ><template #first>
              <b-form-select-option :value="null"
                >--
                {{
                  $t("section.sectionView.selectA", {
                    article: "una",
                    entity: $getVisibleNames("mesh.shift", false, "Jornada"),
                  })
                }}
                --</b-form-select-option
              >
            </template></b-form-select
          >
        </div>
      </div>
      <b-button
        v-can="'teaching.add_section'"
        v-if="allows_crud"
        size="sm"
        variant="primary"
        @click="createSection"
        class="mb-3 mt-3"
        >{{
          $t("reusable.common.addTooltip", {
            entity: $getVisibleNames("teaching.section", false, "Sección"),
          })
        }}</b-button
      >
    </div>

    <!-- <b-input-group v-if="filteredSections.length" size="sm" class="mt-3">
      <b-input-group-prepend is-text>
        <b-icon icon="search"></b-icon>
      </b-input-group-prepend>
      <b-form-input
        id="search-form"
        type="search"
        v-model="input_search"
        placeholder="Buscar..."
      >
      </b-form-input>
      <b-input-group-append>
        <b-button :disabled="!input_search" @click="input_search = ''"
          >Limpiar</b-button
        >
      </b-input-group-append>
    </b-input-group> -->

    <div v-if="show_section_details_create" class="section-container mt-2">
      <!-- Seccion para Crear -->
      <SectionDetails
        :egress_profile_id="selected_egress_profile_id"
        :egress_profile_options="egressProfileOptions"
        :allows_crud="allows_crud"
        :period_id="selected_period_id"
        :shift_id="selected_shift_id"
        :campus_id="selected_campus_id"
        :selected_level="selected_level"
        :period_type="periodType"
        :selected_matter_id="selected_matter_id"
        :identifier_types="identifier_types"
        :roles="roles"
        @created="slotCreatedSection"
        @updated="slotCreatedSection"
        @closed="closeCreateSection"
      ></SectionDetails>
    </div>

    <div
      v-if="show_section_details_edit"
      ref="sectionEditRef"
      class="section-container mt-2"
    >
      <!-- Seccion para Editar -->
      <SectionDetails
        :key="selected_section ? selected_section.id : 'new'"
        :Section="selected_section"
        :egress_profile_id="selected_egress_profile_id"
        :period_type="periodType"
        :allows_crud="allows_crud"
        :identifier_types="identifier_types"
        :roles="roles"
        @updated="slotUpdatedSection"
        @deleted="slotUpdatedSection"
        @closed="closeEditSection"
      ></SectionDetails>
    </div>

    <div class="status-filter-bar">
      <span class="status-filter-label">
        {{ $t("section.sectionView.statusFilter") }}:
      </span>
      <b-form-radio-group
        v-model="selected_is_active"
        :options="statusOptions"
        buttons
        button-variant="outline-primary"
        size="sm"
        class="status-filter-group"
      ></b-form-radio-group>
    </div>

    <SectionTable
      :allows_crud="allows_crud"
      :selected_is_active="selected_is_active"
      :selected_career_id="selected_career_id"
      :selected_egress_profile_id="selected_egress_profile_id"
      :selected_period_id="selected_period_id"
      :selected_shift_id="selected_shift_id"
      :selected_campus_id="selected_campus_id"
      :selected_level="selected_level"
      :selected_matter_id="selected_matter_id"
      :selected_section_view="selected_section_view"
      :fields="fields"
      :reload_key="reload_counter"
      @launch-modal-update="launchModalUpdateSection"
      @ask-delete="askForDelete"
      @reload-table="reload_counter++"
    ></SectionTable>
    <!-- <div class="current-sections">
      <b-table
        v-if="filteredSections.length"
        :items="filteredTableItems"
        :fields="fields"
        thead-class="th-custom-table"
        outlined
        small
        class="custom"
        :caption-top="true"
        bordered
        hover
        show-empty
        empty-filtered-text
        empty-text
      >
        <template v-slot:cell(matter)="row">
          <span class="current-sections-item" v-if="selected_career_id">
            <b-link :id="`popover-button-variant-${row.item.id}`">
              {{ getMatterName(row.item.egress_profile_matter) }}
            </b-link>
            <b-popover
              :target="`popover-button-variant-${row.item.id}`"
              triggers="focus"
            >
              <template #title>Navegación:</template>
              <div>
                <template>
                  <div class="profiles-container">
                    <b-button
                      variant="none"
                      :to="{
                        name: 'MatterProgramView',
                        params: {
                          matter_id: row.item.egress_profile_matter,
                        },
                      }"
                      class="profiles mb-1 text-white"
                    >
                      Ir al
                      {{
                        $getVisibleNames(
                          "manual.matter_program",
                          false,
                          "Programa de la Asignatura"
                        )
                      }}.
                    </b-button> -->
    <!-- TODO: Se comento mientras se trabaja en las Evaluaciones. -->
    <!-- <b-button
                      variant="none"
                      :to="{
                        name: 'PlanificationView',
                        params: {
                          matter_id: row.item.egress_profile_matter,
                        },
                      }"
                      class="profiles mb-1 text-white"
                    >
                      Ir a la planificación.
                    </b-button> -->
    <!-- </div>
                </template>
              </div>
            </b-popover>
          </span>
          <span v-else class="current-sections-item">
            <b-link :id="`popover-button-variant-matter-${row.item.id}`">
              {{
                (matters.find((x) => x.id == row.item.matter) || {}).name || ""
              }}
            </b-link>
            <b-popover
              :target="`popover-button-variant-matter-${row.item.id}`"
              triggers="focus"
            >
              <template #title>Navegación:</template>
              <div>
                <template>
                  <div class="profiles-container">
                    <b-button
                      variant="none"
                      :to="{
                        name: 'OldMatterProgramView',
                        params: {
                          matter_id: row.item.matter,
                        },
                      }"
                      class="profiles mb-1 text-white"
                    >
                      Ir al
                      {{
                        $getVisibleNames(
                          "manual.matter_program",
                          false,
                          "Programa de la Asignatura"
                        )
                      }}.
                    </b-button>
                  </div>
                </template>
              </div>
            </b-popover>
          </span>
        </template>
        <template v-slot:cell(name)="row">
          <span class="current-sections-item">
            <b-link
              :title="
                'Ver ' + $getVisibleNames('teaching.section', false, 'Sección')
              "
              @click="launchModalUpdateSection(row.item)"
              >{{ row.item.name }}</b-link
            >
          </span>
        </template>
        <template v-slot:cell(shift)="row"> -->
    <!-- :variant="row.item.shift % 2 == 0 ? 'secondary' : 'info'" -->
    <!-- <b-badge class="pill-badge" variant="info" pill>
            {{ shiftName(row.item.shift) }}
          </b-badge>
        </template>
        <template v-slot:cell(period)="row">
          {{ periodName(row.item.period) }}
        </template>
        <template v-slot:cell(professors)="row">
          <template
            v-for="professor in users.filter((x) =>
              row.item.professors.includes(x.id)
            )"
          >
            <div :key="row.item.id + '-' + professor.id">
              <b-badge
                v-b-tooltip.v-secondary.noninteractive="professor.email"
                style="cursor: help"
                variant="info"
                pill
              >
                {{ professor.first_name }}
                {{ professor.last_name }}
              </b-badge>
            </div>
          </template>
        </template>
        <template v-slot:cell(action)="row">
          <div class="d-flex justify-content-end">
            <div v-if="!allows_crud">
              <b-button
                size="sm"
                variant="none"
                @click="launchModalUpdateSection(row.item)"
                ><b-icon icon="eye" scale="1"></b-icon
              ></b-button>
            </div>
            <b-button
              v-if="
                user &&
                ([1].includes(user.groups[0]) || user.is_superuser) &&
                allows_crud &&
                row.item &&
                institution &&
                ((institution.current_periods != null &&
                  !institution.current_periods
                    .map((x) => x.id)
                    .includes(row.item.period)) ||
                  institution.current_periods == null ||
                  !row.item.is_active)
              "
              size="sm"
              variant="none"
              :class="{ 'text-danger': row.item.is_active }"
              v-b-tooltip.v-secondary.noninteractive="
                `${
                  row.item.is_active ? 'Cerrar' : 'Abrir'
                } las Notas y Evaluaciones de la ${$getVisibleNames(
                  'teaching.section',
                  false,
                  'Sección'
                )}`
              "
              @click="changeStateSection(row.item)"
            >
              <template v-if="!row.item.is_active">
                <b-icon icon="lock-fill" scale="1"></b-icon>
              </template>
              <template v-else>
                <b-icon icon="unlock-fill" scale="1"></b-icon>
              </template>
            </b-button> -->
    <!-- v-if="institution && institution.internal_use_id != 'duoc.cl'" -->
    <!-- <div>
              <ButtonWrapper :item_id="row.item.id" class="mr-1">
                <template v-slot:btn-slot>
                  <div class="container-btn-three-dots">
                    <b-button
                      variant="secondary"
                      @click="redirectToSection(row.item.id)"
                      @contextmenu.prevent="
                        handleRightClickSection(row.item.id)
                      "
                      class="btn-popover-my-classes mb-2 w-100"
                    >
                      Notas de la
                      {{
                        $getVisibleNames("teaching.section", false, "Sección")
                      }}
                    </b-button>
                    <b-button
                      v-if="institution && institution.show_kl_reports"
                      variant="secondary"
                      class="btn-popover-my-classes mb-2 w-100"
                      @click="redirectToAssessmentStudent(row.item.id)"
                      @contextmenu.prevent="
                        handleRightClickAssessmentStudent(row.item.id)
                      "
                      >Assessment por Estudiante
                    </b-button>
                    <b-button
                      variant="secondary"
                      @click="redirectToEvaluationTeacher(row.item.id)"
                      @contextmenu.prevent="
                        handleRightClickEvaluationTeacher(row.item.id)
                      "
                      class="btn-popover-my-classes mb-2 w-100"
                    >
                      {{
                        $getVisibleNames(
                          "evaluations2.evaluation",
                          true,
                          "Evaluaciones"
                        )
                      }}
                      de la
                      {{
                        $getVisibleNames("teaching.section", false, "Sección")
                      }}
                    </b-button>
                    <b-button
                      v-if="
                        institution &&
                        institution.kl_assessment && institution.show_kl_reports
                      "
                      variant="secondary"
                      @click="redirectToAssessmentRange(row.item.id)"
                      @contextmenu.prevent="
                        handleRightClickAssessmentRange(row.item.id)
                      "
                      class="btn-popover-my-classes w-100"
                    >
                      Reporte Assessment
                    </b-button>
                  </div>
                </template>
              </ButtonWrapper>
            </div>
            <button-edit
              v-if="allows_crud"
              v-can="'teaching.change_section'"
              @click="launchModalUpdateSection(row.item)"
            >
            </button-edit>
            <button-delete
              v-if="allows_crud"
              v-can="'teaching.delete_section'"
              @click="askForDelete(row.item)"
            ></button-delete>
          </div>
        </template>
        <template #empty>
          <div class="text-center p-3">
            No hay datos que coincidan con la búsqueda.
          </div>
        </template>
        <template #emptyfiltered>
          <div class="text-center p-3">
            No hay datos que coincidan con la búsqueda.
          </div>
        </template>
      </b-table> 
    </div>-->
    <!-- Modals -->
    <b-modal
      :title="
        $t('reusable.common.createTooltip', {
          entity: $getVisibleNames('teaching.section', false, 'Sección'),
        })
      "
      hide-footer
      size="xl"
      id="modal-create-section"
    >
      <SectionForm
        :egress_profile_id="selected_egress_profile_id"
        :allows_crud="allows_crud"
        :period_id="selected_period_id"
        :shift_id="selected_shift_id"
        :campus_id="selected_campus_id"
        :selected_level="selected_level"
        :period_type="periodType"
        :selected_matter_id="selected_matter_id"
        @created="slotCreatedSection"
        @updated="slotCreatedSection"
      ></SectionForm>
    </b-modal>
    <b-modal
      :title="
        $t('reusable.common.modifyTooltip', {
          entity: $getVisibleNames('teaching.section', false, 'Sección'),
        })
      "
      hide-footer
      size="xl"
      id="modal-update-section"
    >
      <SectionForm
        :Section="selected_section"
        :egress_profile_id="selected_egress_profile_id"
        :period_type="periodType"
        :allows_crud="allows_crud"
        @updated="slotUpdatedSection"
        @deleted="slotUpdatedSection"
      ></SectionForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters, mapMutations } from "vuex";
import { toast } from "@/utils/utils";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "SectionList",
  components: {
    vSelect,
    SectionForm: () => import("./SectionForm"),
    SectionDetails: () => import("./SectionDetails"),
    SectionTable: () => import("./SectionTable"),
  },
  props: {
    // career_id: {
    //   type: Number,
    // },
    // level: {
    //   type: Number,
    // },
    // period_id: {
    //   type: Number,
    // },
    // campus_id: {
    //   type: Number,
    // },
    // shift_id: {
    //   type: Number,
    // },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected_career_id: null,
      selected_level: null,
      selected_egress_profile_id: null,
      selected_period_id: null,
      profile_type_id: null,
      horizontal_layout: false,
      sections: [],
      levels: [],
      selected_shift_id: null,
      selected_campus_id: null,
      selected_matter_id: null,
      selected_period_type_id: null,
      // Filtro por estado de la Sección: null = todas, true = activas, false = no activas.
      selected_is_active: null,
      // selected_matter_id: Number(this.$route.params.matter_id)
      //   ? Number(this.$route.params.matter_id)
      //   : null,
      selected_section: null,
      selected_section_view: 1,
      input_search: "",
      show_section_details_create: false,
      show_section_details_edit: false,
      identifier_types: [],
      roles: [],
      reload_counter: 0,
      is_restoring_filters: false,
      sync_filters_timeout: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      careers: names.CAREERS,
      campuses: names.CAMPUSES,
      egressProfiles: names.EGRESS_PROFILES,
      cycles: names.CYCLES,
      faculties: names.FACULTIES,
      profileTypes: names.PROFILE_TYPES,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
      periods: names.PERIODS,
      regimes: names.REGIMES,
      shifts: names.SHIFTS,
      section_list: names.SECTIONS,
    }),
    careerList() {
      if (this.profile_type_id == null)
        return this.careers.filter((x) => x.egress_profiles.length > 0);
      else
        return this.careers.filter(
          (x) =>
            x.egress_profiles.length > 0 &&
            x.egress_profile_type == this.profile_type_id
        );
    },
    career() {
      return this.careers.find((x) => x.id == this.selected_career_id);
    },
    egressProfile() {
      if (!this.selected_egress_profile_id) return null;
      return this.egressProfiles.find(
        (x) => x.id == this.selected_egress_profile_id
      );
    },
    // Mientras se está creando o editando una Sección, no se debe poder
    // cambiar el Tipo de Programa / Programa / Perfil de Egreso: cambiarlos
    // modificaría a qué Perfil de Egreso quedaría asociada la Sección.
    isCreatingOrEditingSection() {
      return this.show_section_details_create || this.show_section_details_edit;
    },
    lockedSelectorTooltip() {
      return {
        title: this.$t("section.sectionView.lockedWhileFormOpen", {
          entity: this.$getVisibleNames("teaching.section", false, "Sección"),
        }),
        variant: "secondary",
        disabled: !this.isCreatingOrEditingSection,
      };
    },
    periodType() {
      if (this.egressProfile && this.selected_section_view == 1)
        return this.egressProfile.regime;
      else return this.selected_period_type_id;
    },
    sortMatters() {
      return this.matters
        .map((x) => ({ ...x, label: x.code + " - " + x.name }))
        .sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        });
    },
    statusOptions() {
      return [
        { value: null, text: this.$t("section.sectionView.statusAll") },
        { value: true, text: this.$t("section.sectionView.statusActive") },
        { value: false, text: this.$t("section.sectionView.statusInactive") },
      ];
    },
    sections_view() {
      return [
        {
          value: 1,
          name: this.$t("section.sectionView.filterBy", {
            entity: this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil De Egreso"
            ),
          }),
        },
        {
          value: 2,
          name: this.$t("section.sectionView.filterBy", {
            entity: this.$getVisibleNames(
              "teaching.matter",
              false,
              "Asignatura"
            ),
          }),
        },
      ];
    },
    fields() {
      return [
        {
          key: "matter",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            false,
            "Asignatura"
          ),
          tdClass: "text-left",
          sortable: true,
          // La celda muestra el nombre de la asignatura, no su id: se ordena por nombre
          ordering_key: "egress_profile_matter__matter__name",
          display_column: true,
        },
        {
          // Solo se muestra sin filtro de Perfil de Egreso: con varios Perfiles
          // mezclados en la tabla, esta columna permite identificar a cuál pertenece cada Sección.
          key: this.selected_egress_profile_id == null ? "egress_profile" : "",
          label:
            this.selected_egress_profile_id == null
              ? this.$getVisibleNames(
                  "mesh.egressprofile",
                  false,
                  "Perfil de Egreso"
                )
              : "",
          tdClass: "text-left",
          sortable: false,
          display_column: true,
        },
        {
          key: this.selected_section_view == 1 ? "plan_level" : "",
          label:
            this.selected_section_view == 1
              ? this.$t("section.sectionView.level")
              : "",
          sortable: true,
          tdClass: "text-center",
          display_column: true,
        },
        {
          key: "name",
          label: this.$t("reusable.common.name"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "shift",
          label: String(this.$getVisibleNames("mesh.shift", false, "Jornada")),
          tdClass: "text-center",
          sortable: true,
          ordering_key: "shift__name",
          display_column: true,
        },
        {
          key: "period",
          label: String(this.$getVisibleNames("mesh.period", false, "Período")),
          tdClass: "text-left",
          sortable: false,
          display_column: true,
        },
        {
          key: "professors",
          label: this.$t("section.sectionView.teachers"),
          // Una sección tiene varios docentes: no hay un criterio único por el cual ordenar
          sortable: false,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "action",
          label: "",
          tdClass: "text-right",
          display_column: true,
        },
        // { key: "campus", label: String(this.$getVisibleNames('mesh.campus', false, 'Sede')), sortable: true }, TODO: Mostrar la Sede.
        //{ key: "show_details", label: "Color" },
      ];
    },
    // Perfiles de Egreso elegibles dentro del formulario de creación cuando
    // no hay uno seleccionado en los filtros (respeta el Tipo de Programa).
    egressProfileOptions() {
      const options = [];
      this.careerList.forEach((career) => {
        career.egress_profiles.forEach((egress_profile_id) => {
          const egress_profile = this.egressProfiles.find(
            (x) => x.id == egress_profile_id
          );
          if (!egress_profile) return;
          options.push({
            id: egress_profile.id,
            label:
              career.egress_profiles.length > 1
                ? `${career.name} - ${egress_profile.name}`
                : egress_profile.name,
          });
        });
      });
      return options.sort((a, b) => a.label.localeCompare(b.label));
    },
    egressProfileList() {
      let list = [];
      if (this.career) {
        this.career.egress_profiles.forEach((element) => {
          const instance = this.egressProfiles.find((x) => x.id == element);
          if (instance) list.push(instance);
          else this.$store.dispatch(names.FETCH_EGRESS_PROFILE, element);
        });
      }
      return list;
    },
    filteredCampuses() {
      if (!this.egressProfile) return this.campuses;
      let list = [];
      this.egressProfile.campuses.forEach((campus_id) => {
        const instance = this.sortCampus.find((x) => x.id == campus_id);
        if (instance) list.push(instance);
      });
      return list.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    sortCampus() {
      return [...this.campuses].sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    matterList() {
      let list = [];
      if (!this.selected_egress_profile_id) return list;
      list = this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.selected_egress_profile_id
      );
      if (this.selected_level)
        list = list.filter((x) => x.plan_level == this.selected_level);
      return list;
    },
    epMatterIds() {
      return this.matterList.map((x) => x.id);
    },
    period() {
      if (!this.selected_period_id) return null;
      return this.periods.find((x) => x.id == this.selected_period_id);
    },
    periodList() {
      let periods_list = this.periods.map((period) => ({
        ...period,
        label: `${period.name} De: ${period.start_date} al ${period.end_date}`,
      }));
      if (!this.periodType) return periods_list;
      return periods_list
        .filter((x) => x.period_type == this.periodType)
        .sort(function (a, b) {
          if (a.start_date < b.start_date) return 1;
          if (a.start_date > b.start_date) return -1;
        });
    },
    filteredSections() {
      let list = this.section_list.map((x) => {
        return {
          ...x,
          plan_level: this.getMatterPlanLevel(x.egress_profile_matter),
        };
      });
      if (this.selected_section_view == 1) {
        if (this.selected_career_id == null) return [];
        if (this.selected_egress_profile_id == null) return [];
        if (this.selected_egress_profile_id)
          list = list.filter((x) =>
            this.epMatterIds.includes(x.egress_profile_matter)
          );
        if (this.selected_shift_id)
          list = list.filter((x) => x.shift == this.selected_shift_id);
        if (this.selected_campus_id)
          list = list.filter((x) => x.campus == this.selected_campus_id);
        if (this.selected_level)
          list = list.filter((x) => x.plan_level == this.selected_level);
        if (this.selected_period_id)
          list = list.filter((x) => x.period == this.selected_period_id);
        return list;
      } else {
        list.filter((x) => x.egress_profile_matter == null);
        if (this.selected_matter_id)
          list = list.filter((x) => x.matter == this.selected_matter_id);
        if (this.selected_shift_id)
          list = list.filter((x) => x.shift == this.selected_shift_id);
        if (this.selected_campus_id)
          list = list.filter((x) => x.campus == this.selected_campus_id);
        if (this.selected_level)
          list = list.filter((x) => x.plan_level == this.selected_level);
        if (this.selected_period_id)
          list = list.filter((x) => x.period == this.selected_period_id);
        return list;
      }
    },
    selectedSections() {
      return this.filteredSections.filter((x) => x.show_in_calendar);
    },
    // Filtros actuales serializados para reflejarlos en la URL (query params).
    filterQuery() {
      const query = {};
      if (this.selected_section_view != null)
        query.section_view = String(this.selected_section_view);
      if (this.profile_type_id != null)
        query.profile_type_id = String(this.profile_type_id);
      if (this.selected_career_id != null)
        query.career_id = String(this.selected_career_id);
      if (this.selected_egress_profile_id != null)
        query.egress_profile_id = String(this.selected_egress_profile_id);
      if (this.selected_level != null)
        query.level = String(this.selected_level);
      if (this.selected_period_id != null)
        query.period_id = String(this.selected_period_id);
      if (this.selected_shift_id != null)
        query.shift_id = String(this.selected_shift_id);
      if (this.selected_campus_id != null)
        query.campus_id = String(this.selected_campus_id);
      if (this.selected_matter_id != null)
        query.matter_id = String(this.selected_matter_id);
      if (this.selected_period_type_id != null)
        query.period_type_id = String(this.selected_period_type_id);
      if (this.selected_is_active != null)
        query.is_active = String(this.selected_is_active);
      return query;
    },
  },
  methods: {
    ...mapMutations(["DeleteUserSectionProfessor"]),
    redirectToSection(id) {
      this.$router.push({
        name: "NewFullGradingView",
        params: {
          section_id: id,
        },
      });
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    filterCustom(row) {
      if (
        this.$filtered(
          this.getMatterName(row.egress_profile_matter),
          this.input_search
        ) ||
        this.$filtered(row.plan_level, this.input_search) ||
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(this.shiftName(row.shift), this.input_search) ||
        this.$filtered(this.periodName(row.period), this.input_search)
      ) {
        return true;
      } else {
        false;
      }
    },
    handleRightClickSection(id) {
      const url = this.$router.resolve({
        name: "NewFullGradingView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    redirectToEvaluationTeacher(id) {
      this.$router.push({
        name: "EvaluatorEvaluationsListView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickEvaluationTeacher(id) {
      const url = this.$router.resolve({
        name: "EvaluatorEvaluationsListView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    redirectToAssessmentRange(id) {
      this.$router.push({
        name: "AssessmentRangeSectionView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickAssessmentRange(id) {
      const url = this.$router.resolve({
        name: "AssessmentRangeSectionView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    redirectToProgressionEvaluation(id) {
      this.$router.push({
        name: "ProfessorProgressionReportView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickProgressionEvaluation(id) {
      const url = this.$router.resolve({
        name: "ProfessorProgressionReportView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    redirectToAssessmentStudent(id) {
      this.$router.push({
        name: "AssessmentStudentsView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickAssessmentStudent(id) {
      const url = this.$router.resolve({
        name: "AssessmentStudentsView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    // Limpia los filtros que dependen del Perfil de Egreso (Sede, Nivel,
    // Jornada, Período): al perder el Perfil de Egreso sus selectores
    // desaparecen, pero sin esto conservaban un valor oculto y seguían
    // filtrando la tabla de Secciones.
    resetDependentFilters() {
      this.selected_period_id = null;
      this.selected_campus_id = null;
      this.selected_level = null;
      this.selected_shift_id = null;
    },
    changeSectionView() {
      this.sections = [];
      this.selected_matter_id = null;
      this.selected_career_id = null;
      this.selected_egress_profile_id = null;
      this.selected_period_type_id = null;
      this.selected_period_id = null;
      this.selected_level = null;
      this.selected_campus_id = null;
      this.selected_shift_id = null;
    },
    emitSections(section) {
      const index = this.sections.findIndex((x) => x.id == section.id);
      if (index != -1) {
        const flag = this.sections[index].show_in_calendar;
        this.sections[index].show_in_calendar = !flag;
      }
      //this.emitSelectedSections();
    },
    shiftName(shift_id) {
      const shift = this.shifts.find((x) => x.id == shift_id);
      return shift ? shift.name : "";
    },
    periodName(id) {
      const period = this.periods.find((x) => x.id == id);
      return period ? period.name : "";
    },
    selectAllSections(flag) {
      this.sections.forEach((element) => {
        element.show_in_calendar = flag;
        let checkbox = this.$refs[`checkbox-${element.id}`];
        if (checkbox) {
          try {
            checkbox.checked = flag;
          } catch {
            () => {};
          }
        }
      });

      //this.emitSelectedSections();
    },
    filterCareerOption(option, label, search) {
      return this.$filtered(this.getCareerDisplayName(option), search);
    },
    getCareerDisplayName(career) {
      if (!career) return "";
      if (career.egress_profiles.length == 1) {
        const egress_profile = this.egressProfiles.find(
          (x) => x.id == career.egress_profiles[0]
        );
        if (egress_profile) return egress_profile.name;
      }
      return career.name;
    },
    getMatterName(egress_profile_matter_id) {
      const egress_profile_matter = this.egress_profiles_matters.find(
        (x) => x.id == egress_profile_matter_id
      );
      if (egress_profile_matter) {
        const matter = this.matters.find(
          (x) => x.id == egress_profile_matter.matter
        );
        return matter ? matter.name : "";
      } else return "";
    },
    getMatterPlanLevel(egress_profile_matter_id) {
      if (!egress_profile_matter_id) return null;
      const egress_profile_matter = this.egress_profiles_matters.find(
        (x) => x.id == egress_profile_matter_id
      );
      if (egress_profile_matter) {
        return egress_profile_matter ? egress_profile_matter.plan_level : null;
      } else return null;
    },
    updateColor(section) {
      this.$store
        .dispatch(names.PATCH_SECTION, {
          section_id: section.id,
          item: { color: section.color },
        })
        .then(() => {
          //this.emitSelectedSections();
        });
    },
    changeStateSection(section) {
      if (!isNaN(section.id))
        this.$store
          .dispatch(names.PATCH_SECTION, {
            section_id: section.id,
            item: { is_active: !section.is_active },
          })
          .then((response) => {
            const index = this.sections.findIndex((x) => x.id == response.id);
            if (index != -1) this.sections.splice(index, 1, response);
            toast(
              this.$t("section.sectionView.sectionStatus", {
                entity: this.$getVisibleNames(
                  "teaching.section",
                  false,
                  "Sección"
                ),
                status: response.is_active
                  ? this.$t("section.sectionView.active")
                  : this.$t("section.sectionView.closed"),
              })
            );
          });
    },
    //// emitSelectedSections() {
    //   let sections_id = [];
    //   this.filteredSections.forEach((element) => {
    //     if (element.show_in_calendar) sections_id.push(element.id);
    //   });
    //   this.$emit("update_section_list", sections_id);
    // },
    createSection() {
      // Sin Perfil de Egreso en los filtros, el formulario muestra su propio
      // selector; solo se bloquea si el perfil ya elegido no tiene asignaturas.
      if (
        this.selected_egress_profile_id != null &&
        this.matterList.length == 0
      ) {
        this.$swal({
          title: this.$t("section.sectionView.mustAddSubject", {
            subject: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
            program: this.$getVisibleNames("mesh.career", false, "Programa"),
            section: this.$getVisibleNames(
              "teaching.section",
              false,
              "Sección"
            ),
          }),
          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("section.sectionView.goToMatrix2", {
            matrix: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
          }),
          cancelButtonText: this.$t("reusable.common.close"),
        }).then((result) => {
          if (result.value)
            this.$router.push({
              name: "Matrix2View",
              params: { egress_profile_id: this.selected_egress_profile_id },
            });
        });
        return;
      }
      this.selected_section = {};
      this.show_section_details_create = true;
      this.show_section_details_edit = false;
    },
    // createSectionForMatter(matter) {
    //   this.selected_matter_id = matter.id;
    //   this.$bvModal.show("modal-create-section-for-matter");
    // },
    slotCreatedSection(section) {
      if (section && this.selected_egress_profile_id == null)
        this.showEgressProfileOfSection(section);
      this.$bvModal.hide("modal-create-section-for-matter");
      this.$bvModal.hide("modal-create-section");
      this.sections = this.filteredSections;
      this.show_section_details_create = false;
      this.reload_counter++;
      // this.loadSections();
      // this.selected_matter_id = null;
    },
    // Ajusta los filtros al Perfil de Egreso elegido en el formulario para que
    // la Sección recién creada quede visible en la tabla.
    showEgressProfileOfSection(section) {
      const egress_profile_matter = this.egress_profiles_matters.find(
        (x) => x.id == section.egress_profile_matter
      );
      if (!egress_profile_matter) return;
      const egress_profile_id = egress_profile_matter.egress_profile;
      const career = this.careers.find((x) =>
        x.egress_profiles.includes(egress_profile_id)
      );
      if (!career) return;
      this.selected_career_id = career.id;
      // El watcher de career() asigna el primer perfil; se sobrescribe después.
      this.$nextTick(() => {
        this.selected_egress_profile_id = egress_profile_id;
      });
    },
    closeCreateSection() {
      this.show_section_details_create = false;
    },
    launchModalUpdateSection(section) {
      this.selected_section = section;
      this.show_section_details_create = false;
      this.show_section_details_edit = true;
      this.$nextTick(() => {
        if (this.$refs.sectionEditRef) {
          const top =
            this.$refs.sectionEditRef.getBoundingClientRect().top +
            window.scrollY -
            95;
          window.scrollTo({ top, behavior: "smooth" });
        }
      });
    },
    slotUpdatedSection() {
      this.sections = this.filteredSections;
      this.show_section_details_edit = false;
      this.selected_section = null;
      this.reload_counter++;
      // this.loadSections();
      this.$bvModal.hide("modal-update-section");
    },
    closeEditSection() {
      this.show_section_details_edit = false;
      this.selected_section = null;
    },
    loadSections() {
      if (!this.selected_egress_profile_id) return;
      this.$store
        .dispatch(names.FETCH_EGRESS_PROFILE, this.selected_egress_profile_id)
        .then((ep) => {
          this.levels = [];
          for (let level = 1; level <= ep.semester_amount; level++) {
            this.levels.push(level);
          }
        });
      this.sections = [];
      // let counter = 0;
      this.$store.dispatch(names.FETCH_MATTERS, {
        egress_profile_id: this.selected_egress_profile_id,
      });
      this.$store.dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
        egress_profile_id: this.selected_egress_profile_id,
      });
      this.$store
        .dispatch(names.FETCH_SECTIONS, {
          egress_profile_id: this.selected_egress_profile_id,
        })
        .then((response) => {
          this.sections = [...response];
        });
    },
    // Restaura los filtros desde los query params de la URL al entrar a la vista.
    restoreFiltersFromURL() {
      const query = this.$route.query;
      this.is_restoring_filters = true;
      if (query.section_view != null)
        this.selected_section_view = Number(query.section_view);
      if (query.profile_type_id != null)
        this.profile_type_id = Number(query.profile_type_id);
      if (query.career_id != null)
        this.selected_career_id = Number(query.career_id);
      if (query.egress_profile_id != null)
        this.selected_egress_profile_id = Number(query.egress_profile_id);
      if (query.level != null) this.selected_level = Number(query.level);
      if (query.period_id != null)
        this.selected_period_id = Number(query.period_id);
      if (query.shift_id != null)
        this.selected_shift_id = Number(query.shift_id);
      if (query.campus_id != null)
        this.selected_campus_id = Number(query.campus_id);
      if (query.matter_id != null)
        this.selected_matter_id = Number(query.matter_id);
      if (query.period_type_id != null)
        this.selected_period_type_id = Number(query.period_type_id);
      if (query.is_active != null)
        this.selected_is_active = query.is_active === "true";
      this.$nextTick(() => {
        this.is_restoring_filters = false;
      });
    },
    // Refleja los filtros seleccionados en la URL (sin agregar historial) para
    // que al volver atrás con el navegador se mantenga lo que se había filtrado.
    syncFiltersToURL() {
      if (this.is_restoring_filters) return;
      clearTimeout(this.sync_filters_timeout);
      this.sync_filters_timeout = setTimeout(() => {
        const query = this.filterQuery;
        const currentQuery = this.$route.query;
        const keys = new Set([
          ...Object.keys(query),
          ...Object.keys(currentQuery),
        ]);
        const hasChanged = [...keys].some((k) => query[k] !== currentQuery[k]);
        if (hasChanged) this.$router.replace({ query }).catch(() => {});
      }, 300);
    },
    askForDelete(section) {
      this.$restful
        .Get(
          `/teaching/cascade_delete_objects/?app_label=teaching&model_name=section&id=${section.id}`
        )
        .then((response) => {
          this.$swal({
            title: this.$t("section.sectionView.confirmDelete", {
              entity: this.$getVisibleNames(
                "teaching.section",
                false,
                "Sección"
              ),
            }),
            width: "auto",
            text: this.$t("section.sectionView.deleteWarning"),
            type: "warning",
            footer: `<ul>${response
              .map((objeto) => `<li>${objeto.model}: ${objeto.str}</li>`)
              .join("")}</ul>`,
            showCancelButton: true,
          }).then((result) => {
            if (result.value) {
              this.$store
                .dispatch(names.DELETE_SECTION, section.id)
                .then(() => {
                  let payload = { user_id: this.user.id, section: section };
                  this.DeleteUserSectionProfessor(payload);
                  const index = this.sections.findIndex(
                    (x) => x.id == section.id
                  );
                  if (index != -1) this.sections.splice(index, 1);
                  this.reload_counter++;
                  toast(
                    this.$t("section.sectionView.sectionDeleted", {
                      entity: this.$getVisibleNames(
                        "teaching.section",
                        false,
                        "Sección"
                      ),
                    })
                  );
                });
            }
          });
        });
    },
  },
  created() {
    // if (
    //   (this.institution && this.institution.internal_use_id == "duoc.cl")
    // ) {
    //   this.selected_section_view = 1;
    // }
    // this.selected_career_id = this.career_id;
    // this.selected_level = this.level;
    // this.selected_period_id = this.period_id;
    // this.selected_shift_id = this.shift_id;
    // this.selected_campus_id = this.campus_id;
    this.restoreFiltersFromURL();
    if (
      this.career &&
      this.career.egress_profiles.length > 0 &&
      !this.selected_egress_profile_id
    )
      this.selected_egress_profile_id = this.career.egress_profiles[0];

    // Cargar identifier types y roles
    if (this.identifier_types.length == 0)
      this.$restful.GetAll(`/common/identifer-type/`).then((response) => {
        this.identifier_types = response;
      });
    if (this.roles.length == 0)
      this.$store.dispatch(names.FETCH_ROLES).then((response) => {
        this.roles = response;
      });
  },
  watch: {
    career() {
      // Mientras se restauran filtros desde la URL, no pisar un
      // egress_profile_id ya restaurado. En uso normal (el usuario cambia de
      // programa), sí se debe reasignar siempre al primer perfil de egreso.
      if (
        this.career &&
        this.career.egress_profiles.length > 0 &&
        (!this.is_restoring_filters || !this.selected_egress_profile_id)
      )
        this.selected_egress_profile_id = this.career.egress_profiles[0];
    },
    filterQuery: {
      handler() {
        this.syncFiltersToURL();
      },
      deep: true,
    },
    selected_egress_profile_id() {
      this.loadSections();
      //this.$emit("changed_egress_profile", this.selected_egress_profile_id);
    },
    selected_shift_id() {
      //this.emitSelectedSections();
    },
    selected_campus_id() {
      //this.emitSelectedSections();
    },
    selected_level() {
      //this.emitSelectedSections();
    },
    selected_matter_id(value) {
      if (this.selected_section_view == 2 && value != null)
        this.$store
          .dispatch(names.FETCH_SECTIONS, { matter_id: value })
          .then((response) => {
            this.sections = [...response];
          });
    },
    selected_section_view(value) {
      if (value == 2) {
        this.levels = [];
        for (let i = 1; i <= this.institution.max_semester_amount; i++) {
          this.levels.push(i);
        }
        this.$store.dispatch(names.FETCH_MATTERS);
      }
    },
    matterList() {
      this.matterList.forEach((matter) => {
        matter.sections.forEach((section_id) => {
          this.$store.dispatch(names.FETCH_SECTION, section_id);
        });
      });
    },
    // filteredCampuses() {
    // if (this.filteredCampuses.length > 0 && !this.selected_campus_id) {
    //   this.selected_campus_id = this.filteredCampuses[0].id;
    // }
    // },
  },
};
</script>

<style scoped>
/* ===== Diseño según el estándar (styles_kl.css) ===== */
/* Panel de filtros / contenedores: tarjeta con borde suave y radio estándar */
.section-container {
  padding: 1rem !important;
  margin-inline: 0.2rem;
  background: #eee !important;
  border: 1px solid var(--kl-card-border);
  border-radius: var(--kl-card-radius);
}
/* Labels de los filtros */
p {
  text-align: left;
  margin-bottom: 4px;
  margin-top: 1rem;
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-heading);
}
/* Selects según el estándar (--kl-input-*) */
.section-container >>> select.custom-select {
  height: 40px;
  font-size: var(--kl-fs-body);
  color: var(--kl-text-heading);
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius);
  background-color: var(--kl-surface);
}
.section-container >>> select.custom-select:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
/* v-select (Asignatura) alineado al estándar */
.section-container >>> .vs__dropdown-toggle {
  min-height: 40px;
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius);
  background: var(--kl-surface);
}
/* ---- Botones del popover de acciones (tres puntos) ---- */
.container-btn-three-dots {
  max-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.btn-popover-my-classes {
  padding: 8px 12px !important;
  font-size: var(--kl-fs-body);
  border-radius: 9px !important;
  background: var(--kl-bg-page) !important;
  color: var(--kl-text-heading) !important;
  border: 1px solid var(--kl-border-soft) !important;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.btn-popover-my-classes:hover {
  background: linear-gradient(
    135deg,
    var(--kl-color-primary) 0%,
    var(--kl-color-secondary) 100%
  ) !important;
  color: #ffffff !important;
  border-color: transparent !important;
}
.card-body {
  padding: 0px;
}
.current-sections {
  margin-bottom: 2rem;
  margin-top: 1rem;
}
.select-container {
  display: flex;
}
/* Barra del filtro por estado (control segmentado) */
.status-filter-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-inline: 0.2rem;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
}
.status-filter-label {
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-text-heading);
}
.status-filter-group >>> .btn {
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
}
/* ---- Badges / chips: formato estándar (píldora, 12px, semibold) ---- */
.pill-badge {
  font-size: var(--kl-chip-fs);
}
.section-container >>> .badge-info {
  background: var(--kl-chip-bg);
  color: var(--kl-chip-text);
  border: 1px solid var(--kl-chip-border);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
}
.section-container >>> .badge-secondary {
  background: var(--kl-chip-solid-bg);
  color: var(--kl-chip-solid-text);
  font-size: var(--kl-chip-fs);
  font-weight: var(--kl-chip-fw);
}
/* ---- Enlaces de la tabla (asignatura / nombre de sección) ---- */
.current-sections-item a {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.current-sections-item a:hover {
  color: var(--kl-color-primary-deep);
  text-decoration: underline;
}
.current-sections-item:hover {
  background: var(--kl-surface-hover);
  border-radius: var(--kl-radius-sm);
}
.upper-egress-profile {
  padding-inline: 0.2rem;
}
.upper-selector {
  width: 50%;
  padding-inline: 0.2rem;
}
.lower-selector {
  width: 50%;
  padding-inline: 0.2rem;
  margin-bottom: 2rem;
}
.custom {
  background: rgb(226, 226, 226) !important;
}
.profiles-container {
  width: 100%;
}
/* Botones de navegación del popover (Programa de la Asignatura) */
.profiles {
  background-color: var(--kl-color-primary);
  border-radius: var(--kl-btn-radius);
  padding: 0 2em;
  width: 100%;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  text-align: center;
  transition: background-color 0.2s ease;
}
.profiles:hover {
  background-color: var(--kl-color-primary-hover);
}
table >>> .th-custom-table {
  background-color: var(--primary-color) !important;
}
/* ---- Popover de estudiantes ---- */
.students-popover-list {
  max-height: 200px;
  overflow-y: auto;
}
.students-popover-item {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 2px 3px 2px 0px;
  border-radius: var(--kl-radius-sm);
  font-size: var(--kl-fs-caption);
  color: var(--kl-text-body);
}
.students-popover-item:not(:last-child) {
  border-bottom: 1px solid var(--kl-border-soft);
}
.students-popover-index {
  font-size: 11px;
  color: var(--kl-text-muted);
  flex-shrink: 0;
}
</style>